module.exports = __webpack_public_path__ + "img/content.8ee07edb.png";